import styled from 'styled-components';
import { COLORS } from '@cuemath/comps';

export const PanelContainer = styled.div`
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px;
`;

export const SectionContainer = styled.div`
  margin-bottom: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  overflow: hidden;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 18px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: #e9ecef;
  }
`;

export const SectionHeaderProfile = styled(SectionHeader)`
  cursor: default;
  background: #f0f4f8;

  &:hover {
    background: #f0f4f8;
  }
`;

export const ToggleIcon = styled.div`
  width: 0;
  height: 0;
  border-left: 6px solid ${COLORS.GRAY_DARK};
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  margin-right: 12px;
  transition: transform 0.2s ease;
  transform: ${props => (props.expanded ? 'rotate(90deg)' : 'rotate(0deg)')};
`;

export const SectionTitle = styled.h3`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: ${COLORS.GRAY_DARK};
`;

export const SectionTitleProfile = styled(SectionTitle)`
  color: ${COLORS.COLA};
`;

export const SectionContent = styled.div`
  padding: ${props => (props.expanded ? '18px' : '0 18px')};
  max-height: ${props => (props.expanded ? '5000px' : '0')};
  overflow: hidden;
  transition: max-height 0.3s ease, padding 0.3s ease;
  opacity: ${props => (props.expanded ? '1' : '0')};
`;

// Student Profile Styles
export const ProfileCard = styled.div`
  padding: 16px;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 4px solid ${COLORS.COLA};
  margin-bottom: ${props => (props.$marginBottom ? props.$marginBottom : '0')};
`;

export const ProfileCardBlue = styled(ProfileCard)`
  background: #e7f3ff;
  border-left: 4px solid #007bff;
`;

export const ProfileCardYellow = styled(ProfileCard)`
  background: #fff3cd;
  border-left: 4px solid #ffc107;
`;

export const ProfileRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ProfileRowColumn = styled(ProfileRow)`
  flex-direction: column;
  align-items: flex-start;
`;

export const ParentsContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ProfileLabel = styled.div`
  font-weight: 600;
  font-size: 13px;
  color: ${COLORS.GRAY_DARK};
  margin-right: 12px;
  flex-shrink: 0;
`;

export const ProfileValue = styled.div`
  font-size: 13px;
  color: #495057;
  line-height: 1.5;
`;

export const ProfileValueSpaced = styled(ProfileValue)`
  margin-top: 8px;
  line-height: 1.6;
`;

export const ProfileValueBold = styled(ProfileValue)`
  font-weight: 600;
  margin-bottom: 8px;
`;

export const ProfileValuePitch = styled(ProfileValue)`
  line-height: 1.8;
  font-size: 14px;
`;

export const ProfileValueContext = styled(ProfileValue)`
  font-size: 13px;
  color: #6c757d;
`;

export const ParentBadge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  background: #e7f3ff;
  color: #0056b3;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
`;

// Session Performance Styles
export const MomentCard = styled.div`
  padding: 14px;
  margin-bottom: 12px;
  background: ${props => (props.success ? '#d4edda' : '#fff3cd')};
  border-radius: 6px;
  border-left: 4px solid ${props => (props.success ? '#28a745' : '#ffc107')};
  position: relative;
`;

export const MomentTimestamp = styled.button`
  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;
  font-size: 11px;
  font-weight: 500;
  color: white;
  background: #6c757d;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  margin-bottom: 8px;
  transition: background-color 0.2s ease;

  &:hover {
    background: #5a6268;
  }
`;

export const MomentText = styled.div`
  font-size: 13px;
  line-height: 1.6;
  color: #495057;
`;

export const MomentTextItalic = styled(MomentText)`
  font-style: italic;
`;

export const MomentTextItalicWarning = styled(MomentTextItalic)`
  color: #856404;
`;

export const MomentLabel = styled.div`
  font-weight: 600;
  font-size: 13px;
  color: ${COLORS.GRAY_DARK};
  margin-bottom: 10px;
`;

export const MomentLabelGreen = styled(MomentLabel)`
  color: #28a745;
`;

export const MomentLabelRed = styled(MomentLabel)`
  color: #dc3545;
`;

export const MomentLabelSpaced = styled(MomentLabel)`
  margin-top: 12px;
`;

export const SectionWrapper = styled.div`
  margin-bottom: ${props => props.$marginBottom || '16px'};
`;

export const MomentsWrapper = styled.div`
  margin-bottom: 24px;
`;

export const QuoteText = styled.div`
  font-style: italic;
  margin-bottom: 8px;
`;

export const ToneText = styled.span`
  font-size: 13px;
  color: #6c757d;
`;

export const BadgesWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
`;

export const PriorityWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 8px;
`;

// Parent Sentiment Styles
export const UrgencyBadge = styled.span`
  display: inline-block;
  padding: 6px 12px;
  background: ${props => {
    if (props.level && props.level.includes('HOT')) return '#dc3545';
    if (props.level && props.level.includes('WARM')) return '#ffc107';
    return '#6c757d';
  }};
  color: white;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 12px;
`;

export const QuoteBlock = styled.div`
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 3px solid #6c757d;
  margin-top: 8px;
  margin-bottom: 12px;
  font-size: 13px;
  color: #495057;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const QuoteBlockWhite = styled(QuoteBlock)`
  background: white;
`;

// Next Actions Styles
export const ActionCard = styled.div`
  padding: 14px;
  margin-bottom: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 4px solid #007bff;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const PriorityBadge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  background: ${props => {
    if (props.priority === 1) return '#dc3545';
    if (props.priority === 2) return '#ffc107';
    if (props.priority === 3) return '#28a745';
    return '#6c757d';
  }};
  color: white;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
`;

// Messages Styles
export const MessageCard = styled.div`
  padding: 16px;
  margin-bottom: 12px;
  background: #e7f3ff;
  border-radius: 6px;
  border-left: 4px solid #007bff;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ChannelBadge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  background: #28a745;
  color: white;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
`;

// Shared Components
export const TimestampButton = styled.button`
  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;
  font-size: 11px;
  font-weight: 500;
  color: white;
  background: #6c757d;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  margin: 0 2px;
  transition: background-color 0.2s ease;

  &:hover {
    background: #5a6268;
  }

  &:disabled {
    background: #adb5bd;
    cursor: not-allowed;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px 24px;
  color: #6c757d;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
`;
